export default __webpack_public_path__ + "static/media/img-proj-dlt-driver.db064895.png";